export default __webpack_public_path__ + "static/footer-logo-4852f5cd0466dff6476f406b6078461f.svg";